"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefix = _interopRequireDefault(require("../../prefix"));

var _HelpBlock = _interopRequireDefault(require("react-bootstrap/lib/HelpBlock"));

var _IconError = _interopRequireDefault(require("../../Icons/IconError"));

var _IconWarning = _interopRequireDefault(require("../../Icons/IconWarning"));

var HelpBlockContainer = function HelpBlockContainer(_ref) {
  var message = _ref.message,
      status = _ref.status;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "help-block__wrapper"
  }, status === "error" ? /*#__PURE__*/_react["default"].createElement(_IconError["default"], null) : status === "warning" ? /*#__PURE__*/_react["default"].createElement(_IconWarning["default"], null) : "", status && /*#__PURE__*/_react["default"].createElement(_HelpBlock["default"], {
    bsClass: "".concat(_prefix["default"], "help-block")
  }, message));
};

var _default = HelpBlockContainer;
exports["default"] = _default;